import { A as push, N as attr_class, I as attr, J as escape_html, D as pop } from "./index2.js";
import "./Select.svelte_svelte_type_style_lang.js";
function InputFrame($$payload, $$props) {
  push();
  const {
    label,
    children,
    info,
    large,
    small,
    error,
    $$slots,
    $$events,
    ...props
  } = $$props;
  $$payload.out.push(`<div${attr_class("frame svelte-1vtbx9z", void 0, { "large": large, "small": small, "error": error })}>`);
  if (label && props.for) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<label${attr("for", props.for)} class="svelte-1vtbx9z">`);
    if (typeof label === "string") {
      $$payload.out.push("<!--[-->");
      $$payload.out.push(`${escape_html(label)}`);
    } else {
      $$payload.out.push("<!--[!-->");
      label($$payload);
      $$payload.out.push(`<!---->`);
    }
    $$payload.out.push(`<!--]--></label>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> <div class="inputs svelte-1vtbx9z">`);
  children($$payload);
  $$payload.out.push(`<!----></div> `);
  if (error) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<small class="svelte-1vtbx9z">${escape_html(error)}</small>`);
  } else {
    $$payload.out.push("<!--[!-->");
    if (info) {
      $$payload.out.push("<!--[-->");
      $$payload.out.push(`<small class="svelte-1vtbx9z">${escape_html(info)}</small>`);
    } else {
      $$payload.out.push("<!--[!-->");
      $$payload.out.push(`<small class="svelte-1vtbx9z"> </small>`);
    }
    $$payload.out.push(`<!--]-->`);
  }
  $$payload.out.push(`<!--]--></div>`);
  pop();
}
export {
  InputFrame as I
};
